import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
    const initializeBlock = function() {

        // sliders
        var splideElements = document.querySelectorAll('.photo-gallery-section__bna__slider');

        if (splideElements.length > 0) {
            splideElements.forEach(function (splideElement) {
                const counter = splideElement.querySelector('.slider-info .slider-numbers');
                const section = splideElement.closest('.photo-gallery-section');
                const isSubGallery = section && section.classList.contains('photo-gallery-section--sub');
                const perPage = isSubGallery ? 2 : 3;

                // Pass each splideElement to the Splide constructor
                var splide = new Splide(splideElement, {
                    type: 'slider',
                    speed: 1000,
                    arrows: true,
                    pagination: false,
                    rewind: false,
                    perPage: perPage,
                    perMove: 1,
                    gap: 10, 
                    waitForTransition: false,
                    arrowPath: 'M4.9908 8.75L5.6508 8L2.1308 4.87L16.8208 4.87L16.8208 3.87L2.1408 3.87L5.6608 0.739999L5.0008 -0.0100013C4.9208 0.0699987 -0.0591999 4.47 0.1208 4.36C-0.0491997 4.28 4.8908 8.64 5.0008 8.73L4.9908 8.75Z',
                    breakpoints: {
                        960: { perPage: 1 }  
                    }
                
                });
                splide.mount();

                // Function to update the counter
                function updateCounter(splide) {
                    if (counter) {
                        var currentSlide = splide.index + 1;  // +1 because index is 0-based
                        var totalSlides = splide.length;
                        counter.textContent = `${currentSlide}/${totalSlides}`;
                    }
                }

                // Initial counter update
                updateCounter(splide);

                // Update counter on slide change
                splide.on('move', function () {
                    updateCounter(splide);
                });
            });
        }
    }
    
    if (window.acf) {
        // Initialize dynamic block preview (editor).
        window.acf.addAction('render_block_preview/type=photo-gallery-section', initializeBlock);
    } else {
        // Initialize on the frontend.
        initializeBlock();
    }
});
